import { render, staticRenderFns } from "./NavbarIcons.vue?vue&type=template&id=5ad8eaf8&scoped=true"
import script from "./NavbarIcons.vue?vue&type=script&lang=ts"
export * from "./NavbarIcons.vue?vue&type=script&lang=ts"
import style0 from "./NavbarIcons.vue?vue&type=style&index=0&id=5ad8eaf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8eaf8",
  null
  
)

export default component.exports